import IdentifiableDto from "modules/base/dto/IdentifiableDto";

export class CaptchaTypeParametersEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number} */
		this.width = null;
		/** @type {string} */
		this.alphabet = null;
		/** @type {number} */
		this.height = null;
		/** @type {string} */
		this.backgroundColor = null;
		/** @type {string} */
		this.fontName = null;
        /** @type {number} */
		this.frameDelay = null;
        /** @type {number} */
		this.horizontalPad = null;
        /** @type {number} */
		this.fontSize = null;
        /** @type {string} */
		this.fontColor = null;
        /** @type {string} */
		this.fontStrokeColor = null;
        /** @type {number} */
		this.startEnd = null;
        /** @type {number} */
		this.fadeInSteps = null;
        /** @type {number} */
		this.stopSteps = null;
        /** @type {number} */
		this.waitBetweenCharacters = null;
        /** @type {number} */
		this.rowDelay = null;
        /** @type {string} */
		this.fadeInMode = null;
        /** @type {number} */
		this.noiseAmount = null;
        /** @type {number} */
        this.lightCount = null;
        /** @type {string} */
        this.lightColor = null;
        /** @type {number} */
        this.minRadius = null;
        /** @type {number} */
        this.maxRadius = null;
        /** @type {string} */
        this.minSpeed = null;
        /** @type {string} */
        this.maxSpeed = null;
        /** @type {string} */
        this.mainRadius = null;
        /** @type {string} */
        this.mainSpeed = null;
        /** @type {number} */
        this.squareWidth = null;
        /** @type {number} */
        this.squareHeight = null;
        /** @type {string} */
        this.squareColor = null;
        /** @type {string} */
        this.squareStrokeColor = null;
        /** @type {string} */
        this.fadeShape = null;
        /** @type {number} */
        this.showSteps = null;
        /** @type {number} */
        this.fadeNoise = null;
        /** @type {number} */
        this.moveSteps = null;
        /** @type {string} */
        this.addMotionBlur = null;
        /** @type {number} */
        this.riseSteps = null;
        /** @type {string} */
        this.locale = null;
        /** @type {string} */
        this.miniGameCategory = null;
	}

	/**
	 * @typedef {Object} _CaptchaTypeParametersEditDtoProps
	 * @property {number} width
	 * @property {number} height
	 * @property {string} alphabet
	 * @property {string} backgroundColor
	 * @property {string} fontName
     * @property {number} frameDelay
     * @property {number} horizontalPad
     * @property {number} fontSize
     * @property {string} fontColor
     * @property {string} fontStrokeColor
     * @property {number} startEnd
     * @property {number} fadeInSteps
     * @property {number} stopSteps
     * @property {number} waitBetweenCharacters
     * @property {number} rowDelay
     * @property {string} fadeInMode
     * @property {number} noiseAmount
     * @property {number} lightCount
     * @property {string} lightColor
     * @property {number} minRadius
     * @property {number} maxRadius
     * @property {string} minSpeed
     * @property {string} maxSpeed
     * @property {string} mainRadius
     * @property {string} mainSpeed
     * @property {number} squareWidth
     * @property {number} squareHeight
     * @property {string} squareColor
     * @property {string} squareStrokeColor
     * @property {string} fadeShape
     * @property {number} showSteps
     * @property {number} fadeNoise
     * @property {number} moveSteps
     * @property {string} addMotionBlur
     * @property {number} riseSteps
     * @property {string} locale
     * @property {string} miniGameCategory
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaTypeParametersEditDtoProps} CaptchaTypeParametersEditDtoProps
	 */
	/**
	 *
	 * @param {CaptchaTypeParametersEditDtoProps} props
	 * @returns {CaptchaTypeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.width = props.width;
		this.alphabet = props.alphabet;
		this.height = props.height;
		this.backgroundColor = props.backgroundColor;
		this.fontName = props.fontName;
        this.frameDelay = props.frameDelay;
        this.horizontalPad = props.horizontalPad;
    	this.fontSize = props.fontSize;
		this.fontColor = props.fontColor;
		this.fontStrokeColor = props.fontStrokeColor;
		this.startEnd = props.startEnd;
		this.fadeInSteps = props.fadeInSteps;
		this.stopSteps = props.stopSteps;
		this.waitBetweenCharacters = props.waitBetweenCharacters;
		this.rowDelay = props.rowDelay;
		this.fadeInMode = props.fadeInMode;
		this.noiseAmount = props.noiseAmount;
		this.lightCount = props.lightCount;
		this.lightColor = props.lightColor;
		this.minRadius = props.minRadius;
		this.maxRadius = props.maxRadius;
		this.minSpeed = props.minSpeed;
		this.maxSpeed = props.maxSpeed;
		this.mainRadius = props.mainRadius;
		this.mainSpeed = props.mainSpeed;
		this.squareWidth = props.squareWidth;
		this.squareHeight = props.squareHeight;
		this.squareColor = props.squareColor;
		this.squareStrokeColor = props.squareStrokeColor;
		this.fadeShape = props.fadeShape;
		this.showSteps = props.showSteps;
		this.fadeNoise = props.fadeNoise;
		this.moveSteps = props.moveSteps;
		this.addMotionBlur = props.addMotionBlur;
        this.riseSteps = props.riseSteps;
        this.locale = props.locale;
        this.miniGameCategory = props.miniGameCategory;
		return this;
	}
}

export default CaptchaTypeParametersEditDto;
